import { render } from "./CometChatReceiverVideoMessageBubble.vue?vue&type=template&id=297625a8&scoped=true"
import script from "./CometChatReceiverVideoMessageBubble.vue?vue&type=script&lang=js"
export * from "./CometChatReceiverVideoMessageBubble.vue?vue&type=script&lang=js"

import "./CometChatReceiverVideoMessageBubble.vue?vue&type=style&index=0&id=297625a8&scoped=true&lang=css"
import "./CometChatReceiverVideoMessageBubble.vue?vue&type=style&index=1&id=297625a8&lang=css"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-297625a8"]])

export default __exports__